import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Trash2 = createReactComponent("Trash2", ["svg", defaultAttributes, [["polyline", {
  points: "3 6 5 6 21 6",
  key: "1xemgo"
}], ["path", {
  d: "M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2",
  key: "a5em8a"
}], ["line", {
  x1: "10",
  y1: "11",
  x2: "10",
  y2: "17",
  key: "15guvf"
}], ["line", {
  x1: "14",
  y1: "11",
  x2: "14",
  y2: "17",
  key: "1thc97"
}]]]);
export default Trash2;